export const SocialData = [
  {
    platform: 'Linkedin',
    icon: require('../../assets/icons/linkedin.png'),
    link: 'https://www.linkedin.com/in/maria-ten/',
  },
  {
    platform: 'Github',
    icon: require('../../assets/icons/github.png'),
    link: 'https://github.com/mariatens',
  },
  {
    platform: 'Email',
    icon: require('../../assets/icons/email.png'),
    link: 'mailto:mtens17@gmail.com',
  },
];
